import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Pagination,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

const WarehouseInventoryTable = (props) => {
  const [warehouseinventoryDispatchData, setWarehouseInventoryDispatchData] =
    useState([]);
  const {
    inventoryData,
    setInventoryData,
    handleNavigateToEditWarehouseInventoryDispatch,
    handleDelete,
    setSelectedDispatchId,
    handleStatusStyle,
    currentPage,
    totalPage,
    setCurrentPage,
    handleStatusUpdate,
    LoadingSpinner,
    loading,
  } = props;
  useEffect(() => {
    const addData = inventoryData.map((item) => ({
      ...item,
      selected: false,
    }));
    setWarehouseInventoryDispatchData(addData);
  }, [inventoryData]);

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => setCurrentPage(number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }
  const edit = <Tooltip id="edit">Edit</Tooltip>;
  const Delete = <Tooltip id="Delete">Delete</Tooltip>;
  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>ID</th>
            <th>PR ID</th>
            <th>Store</th>
            <th>status</th>
            <th>dispatch Date</th>
            <th>dispatch By</th>
            <th>Invoice</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7">
                <LoadingSpinner />
              </td>
            </tr>
          ) : warehouseinventoryDispatchData &&
            warehouseinventoryDispatchData.length === 0 ? (
            <tr>
              <td colSpan="7">
                <center>No record found</center>
              </td>
            </tr>
          ) : (
            warehouseinventoryDispatchData &&
            warehouseinventoryDispatchData.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.purchase_request_id}</td>
                <td>{item.store ? item.store.name : ""}</td>
                <td>{handleStatusStyle(item.status_label)}</td>
                <td>{item.dispatched_date || ""}</td>
                <td>{item.dispatched_by || ""}</td>
                <td>
                  {item.pdf_url ? (
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#007bff",
                      }}
                      onClick={() => window.open(item.pdf_url, "_blank")}
                    >
                      <i
                        className="fa fa-file-pdf-o"
                        style={{ fontSize: "28px" }}
                      />{" "}
                    </button>
                  ) : (
                    ""
                  )}
                </td>

                <td
                  style={{ display: "flex", gap: "10px", flexDirection: "row" }}
                >
                  {item.status === 4 && (
                    <OverlayTrigger placement="top" overlay={Delete}>
                      <Button
                        className="btn-simple btn btn-xs btn-danger"
                        simple
                        bsStyle="success"
                        bsSize="xs"
                        style={{ border: "none" }}
                        onClick={() => handleDelete(item.id)}
                      >
                        <i class="fa fa-times" style={{ fontSize: "16px" }} />
                      </Button>
                    </OverlayTrigger>
                  )}
                  <OverlayTrigger placement="top" overlay={edit}>
                    <Button
                      simple
                      bsStyle="success"
                      bsSize="xs"
                      style={{ border: "none" }}
                      onClick={() =>
                        handleNavigateToEditWarehouseInventoryDispatch(item.id)
                      }
                    >
                      <i
                        class="fa fa-edit"
                        style={{ fontSize: "16px", color: "#FEA405" }}
                      />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Pagination bsSize="medium">{items}</Pagination>
      </div>
    </>
  );
};
export default WarehouseInventoryTable;
